<template>
  <v-card>
    <v-toolbar dark color="#06377a">
      <v-toolbar-title>
        Upload Material
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn class="mr-1" icon dark @click="closeDialog()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <div class="mt-2">
        <v-row>
          <v-col md="4">
            <v-file-input
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, xlsx, .xls"
              v-model="file_upload"
              placeholder="Choose File"
              prepend-icon="mdi-microsoft-excel"
              label="Choose File"
              v-on:change="onChange()"
            ></v-file-input>
          </v-col>

          <v-col md="1">
            <v-btn
              :disabled="disabledUploadButton"
              depressed
              color="#1d6c40"
              class="mt-3"
              style="color: #fff"
              :loading="isLoading"
              v-on:click="onUpload()"
            >
              Upload
            </v-btn>
          </v-col>

          <v-col md="5" v-if="count_upload_process">
            <div class="d-flex pt-4" style="gap: 15px">
              <div style="color: green">
                {{
                  data_upload_process.filter((e) => e.status === "success")
                    .length
                }}
                data upload success
              </div>
              <div style="color: red">
                {{
                  data_upload_process.filter((e) => e.status === "failed")
                    .length
                }}
                data upload failed
              </div>
            </div>
          </v-col>
        </v-row>
      </div>

      <div
        style="height: 320px; background-color: rgb(247, 248, 248); margin-bottom: 10px; overflow-y: scroll"
      >
        <div>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" width="20%">
                    Item Code
                  </th>
                  <th class="text-left" width="20%">
                    Item Name
                  </th>
                  <th class="text-left" width="20%">
                    Item Description
                  </th>
                  <th class="text-left" width="20%">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in data_upload_process"
                  :key="index"
                  :style="
                    row.status === 'success'
                      ? 'background-color: #C8E6C9; color: #1B5E20'
                      : 'background-color: #FFEBEE; color: #D32F2F'
                  "
                >
                  <td class="py-2">{{ row.inc_code }}</td>
                  <td class="py-2">{{ row.item_name }}</td>
                  <td class="py-2">{{ row.item_description }}</td>
                  <td class="py-2">
                    <span v-html="row.message"></span>

                    <v-icon
                      v-if="row.status === 'success'"
                      color="#43A047"
                      style="font-size: 17px; margin-left: 3px"
                    >
                      mdi mdi-check-circle
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </v-card-text>

    <v-dialog
      v-if="dialogConfirmUpload"
      v-model="dialogConfirmUpload"
      max-width="380"
      scrollable
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Upload Material Excel File
        </v-card-title>
        <v-card-text>
          <xlsx-read :file="file">
            <xlsx-json parsed="">
              <template #default="{collection}">
                <div v-if="collection && collection[0].inc_code">
                  Are you sure to upload {{ collection.length }} data material
                  from excel file?
                </div>

                <div v-else>
                  Data material not available
                </div>
              </template>
            </xlsx-json>
          </xlsx-read>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            class="mr-2"
            text
            @click="dialogConfirmUpload = false"
          >
            Cancel
          </v-btn>

          <xlsx-read :file="file">
            <xlsx-json parsed="">
              <template #default="{collection}">
                <v-btn
                  v-if="collection && collection[0].inc_code"
                  color="#1d6c40"
                  dark
                  :loading="isLoading"
                  v-on:click="uploadData(collection)"
                >
                  Upload
                </v-btn>
              </template>
            </xlsx-json>
          </xlsx-read>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { XlsxRead, XlsxJson } from "vue-xlsx"
import moment from "moment"

export default {
  components: {
    XlsxRead,
    XlsxJson,
  },
  data() {
    return {
      name: "CatalogUploadMaterialSection",
      title: "Catalog Upload Material",
      file_upload: null,
      data_upload: null,
      data_upload_process: null,
      loading: false,
      isLoading: false,
      dialogConfirmUpload: false,
      disabledUploadButton: true,
      count_upload_process: false,

      //storage.....................................
      storage_user_id: atob(localStorage.getItem("user_id")),
      storage_username: atob(localStorage.getItem("username")),
      storage_fullname: atob(localStorage.getItem("fullname")),
      storage_company_id: atob(localStorage.getItem("company_id")),
      storage_company_name: atob(localStorage.getItem("company_name")),
      storage_role: atob(localStorage.getItem("role")),
      storage_server: atob(localStorage.getItem("server")),
      storage_departement_id: atob(localStorage.getItem("departement_id")),
    }
  },
  mounted() {},
  watch: {},
  methods: {
    closeDialog() {
      this.$emit("closeDialog")
    },

    onChange() {
      this.data_upload_process = []
      this.disabledUploadButton = this.file_upload ? false : true
      this.count_upload_process = false
    },

    onUpload() {
      this.dialogConfirmUpload = true
      this.file = this.file_upload
    },

    async uploadData(data) {
      // alert(JSON.stringify(data))
      this.dialogConfirmUpload = false
      this.data_upload = data
      this.data_upload_process = []
      this.isLoading = true
      this.count_upload_process = true

      var upload_id = `${this.storage_user_id}${moment().format(
        "MMYY"
      )}${Math.floor(Math.random() * 90000) + 10000}`

      for (const row of this.data_upload) {
        row.upload_id = upload_id

        const validation = this.validation(row)
        var upload_status = null
        var upload_message = null

        if (!validation.error) {
          var uploadDataProcess = await this.uploadDataProcess(row)
          upload_status = uploadDataProcess.status ? "success" : "failed"
          upload_message = uploadDataProcess.message
        } else {
          upload_status = "failed"
          upload_message = validation.message
        }

        var datax = {
          inc_code: row.inc_code,
          item_name: row.item_name || "-",
          item_description: row.item_description || "-",
          status: upload_status,
          message: upload_message,
        }

        this.data_upload_process.push(datax)
      }

      this.isLoading = false
      this.disabledUploadButton = true
    },

    async uploadDataProcess(data) {
      let url = this.base_url + "material/upload/submit"

      const param = {
        request_by: this.storage_fullname,
        inc_code: data.inc_code || "",
        inc_name: data.item_name || "",
        additional_information: data.item_description || "",
        colloquial_name: data.colloquial_name || "",
        material_number: "",
        company: "3100",
        plant: data.plant || "",
        industry_sector: data.industry_sector || "",
        material_type: data.material_type || "",
        description: data.item_description || "",
        base_unit: data.base_unit || "",
        division: data.division || "",
        material_group: data.material_group || "",
        external_group: data.external_group || "",
        old_material_number: data.old_material_no || "",
        lab_office: data.lab_office || "",
        basic_data_text: data.basic_data_text || "",
        basic_material: data.basic_material || "",
        purchasing_group: data.purchasing_group || "",
        order_unit: data.order_unit || "",
        automatic_po: data.automatic_po || "",
        purchasing_value_key: data.purchasing_value_key || "",
        source_list: data.source_list || "",
        manufacturer: data.manufacturer || "",
        part_number: data.part_number || "",
        original_part_number: data.part_number || "",
        remarks: data.remarks || "",
        mrp_group: data.mrp_group || "",
        mrp_type: data.mrp_type || "",
        mrp_control: data.mrp_control || "",
        mrp_profile: data.mrp_profile || "",
        lot_size_procedure: data.lot_size_procedure || "",
        proc_type: data.procurement_type || "",
        special_proc: data.special_procurement || "",
        planned_delivery_time: data.planned_delivery_time || "",
        availibility_check: data.availibility_check || "",
        valuation_category: data.valuation_category || "",
        valuation_type: data.valuation_type || "",
        valuation_class: data.valuation_class || "",
        price_control: data.price_control || "",
        storage_location: data.storage_location || "",
        price: data.price || "",
        status: "CAT",
        requester: this.storage_user_id,
        cataloguer: this.storage_user_id,
        approver: "",
        json_inc_attribute: "",
        requester_description: "",
        requester_additional_info: "",
        requester_json_inc: "",
        type_input: "UPLOAD",
        inserted_by: this.storage_user_id,
        role: this.storage_role,
        user_id: this.storage_user_id,
        upload_id: data.upload_id || "",
      }

      var res = {}

      try {
        const response = await this.axios.post(url, param)
        if (response.status === 200) {
          res = {
            status: true,
            message: "success",
          }
        } else {
          res = {
            status: false,
            message: response.data.message,
          }
        }

        return res
      } catch (error) {
        res = {
          status: false,
          message: "failed to upload excel data",
        }

        return res
      }
    },

    validation(data) {
      var error_status = false
      var error_message = ""

      if (!data.inc_code || data.inc_code === "") {
        error_status = true
        error_message += "INC Code is empty<br />"
      }

      if (!data.item_description || data.item_description === "") {
        error_status = true
        error_message += "Item Description is empty<br />"
      }

      if (!data.basic_data_text || data.basic_data_text === "") {
        error_status = true
        error_message += "Basic Data Text is empty<br />"
      }

      if (!data.plant || data.plant === "") {
        error_status = true
        error_message += "Plant is empty<br />"
      }

      if (!data.base_unit || data.base_unit === "") {
        error_status = true
        error_message += "Base Unit is empty<br />"
      }

      if (!data.automatic_po || data.automatic_po === "") {
        error_status = true
        error_message += "Automatic PO is empty<br />"
      }

      if (!data.source_list || data.source_list === "") {
        error_status = true
        error_message += "Source List is empty<br />"
      }

      if (!data.purchasing_group || data.purchasing_group === "") {
        error_status = true
        error_message += "Purchasing Group is empty<br />"
      }

      if (!data.purchasing_value_key || data.purchasing_value_key === "") {
        error_status = true
        error_message += "Purchasing Value Key is empty<br />"
      }

      if (!data.mrp_group || data.mrp_group === "") {
        error_status = true
        error_message += "MRP Group is empty<br />"
      }

      if (!data.mrp_type || data.mrp_type === "") {
        error_status = true
        error_message += "MRP Type is empty<br />"
      }

      if (!data.mrp_control || data.mrp_control === "") {
        error_status = true
        error_message += "MRP Control is empty<br />"
      }

      if (!data.mrp_profile || data.mrp_profile === "") {
        error_status = true
        error_message += "MRP Profile is empty<br />"
      }

      if (!data.industry_sector || data.industry_sector === "") {
        error_status = true
        error_message += "Industry Sector is empty<br />"
      }

      if (!data.material_type || data.material_type === "") {
        error_status = true
        error_message += "Material Type is empty<br />"
      }

      if (!data.division || data.division === "") {
        error_status = true
        error_message += "Division is empty<br />"
      }

      if (!data.material_group || data.material_group === "") {
        error_status = true
        error_message += "Material Group is empty<br />"
      }

      if (!data.external_group || data.external_group === "") {
        error_status = true
        error_message += "External Group is empty<br />"
      }

      if (!data.basic_material || data.basic_material === "") {
        error_status = true
        error_message += "Basic Material is empty<br />"
      }

      if (!data.lot_size_procedure || data.lot_size_procedure === "") {
        error_status = true
        error_message += "Lot Size Procedure is empty<br />"
      }

      if (!data.special_procurement || data.special_procurement === "") {
        error_status = true
        error_message += "Procurement Type is empty<br />"
      }

      if (!data.procurement_type || data.procurement_type === "") {
        error_status = true
        error_message += "Procurement Type is empty<br />"
      }

      if (!data.planned_delivery_time || data.planned_delivery_time === "") {
        error_status = true
        error_message += "Planned Delivery Time is empty<br />"
      }

      if (!data.availibility_check || data.availibility_check === "") {
        error_status = true
        error_message += "Availibility Check Type is empty<br />"
      }

      if (!data.valuation_class || data.valuation_class === "") {
        error_status = true
        error_message += "Valuation Class is empty<br />"
      }

      if (!data.price_control || data.price_control === "") {
        error_status = true
        error_message += "Price Control Type is empty<br />"
      }

      if (!data.storage_location || data.storage_location === "") {
        error_status = true
        error_message += "Storage Location Type is empty<br />"
      }

      if (!error_status) {
        error_message = "Success"
      }

      const response = {
        error: error_status,
        message: error_message,
      }

      return response
    },
  },
}
</script>
